import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Search as IconSearch } from "react-feather";
import { useKeyPress } from "../../hooks/useKeyPress";
import "./SiteSearch.scss";
import { usePortal } from "../../hooks/usePortal";

interface Props {
  formAction: string;
  paramName: string;
  lang: {
    search: string;
  };
}

export const SiteSearch: React.FC<Props> = props => {
  const portal = usePortal();
  const [open, setOpen] = useState(false);
  useKeyPress("Escape", () => {
    setOpen(false);
  });

  return (
    <>
      <div
        className="Icon"
        onClick={() => setOpen(true)}
        style={{ opacity: 0.64 }}
      >
        <IconSearch size={22} />
      </div>
      {ReactDOM.createPortal(
        <AnimatePresence>
          {open && (
            <motion.div
              className="SiteSearch__Panel"
              onClick={() => setOpen(false)}
              initial={{ opacity: 0, scale: 0.75 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.97 }}
              transition={{ type: "spring", damping: 1000, stiffness: 200 }}
            >
              <form
                method="get"
                onClick={(e) => e.stopPropagation()}
                action={props.formAction}
                className="SiteSearch__Container"
              >
                <div className="SiteSearch__Border">
                  <input
                    name={props.paramName}
                    className="SiteSearch__TextField"
                  />
                  <button type="submit" className="SiteSearch__SubmitButton">
                    {props.lang.search}
                  </button>
                </div>
              </form>
            </motion.div>
          )}
        </AnimatePresence>,
        portal
      )}
    </>
  );
};
